// extracted by mini-css-extract-plugin
export default {"galleryItem":"GalleryItem_galleryItem__wOuO6"};